//请自行添加语言资源
const deliveryWarehouse = {
  warehouseNo:'发货仓编号',
  warehouseName:'发货仓客户名称',
  createTime:"创建时间",
  creator:"创建用户",
  updateTime:"更新时间",
  updater:"更新用户",
  msg:{
  }
};
export default deliveryWarehouse



// WEBPACK FOOTER //
// ./src/page/md/deliveryWarehouse/lang/deliveryWarehouse.zh.js